
import BestellungLogic from "@/logic/bestellung/bestellung_logic"
import Vue from "vue"
import Component from "vue-class-component"

@Component
export default class Bestellung extends Vue {
  logic: BestellungLogic = null

  mounted() {
    this.logic = new BestellungLogic()
    this.logic.init(this.$route.params.bestellungId)
  }
}
